const middleware = {}

middleware['main'] = require('../src/middleware/main.ts')
middleware['main'] = middleware['main'].default || middleware['main']

export default middleware
